import Clarity from '@microsoft/clarity';

let configuredProjectId = '';
let initializedProjectId = '';

const isBrowser = typeof window !== 'undefined';

const getProjectId = () => configuredProjectId;

export const setClarityProjectId = (value) => {
  configuredProjectId = String(value || '').trim();
};

export const clarityEnabled = () => isBrowser && Boolean(getProjectId());

export const initClarity = () => {
  if (!clarityEnabled()) return false;

  const projectId = getProjectId();
  if (initializedProjectId === projectId) return true;

  try {
    Clarity.init(projectId);
    initializedProjectId = projectId;
    return true;
  } catch (error) {
    // Ignore Clarity failures so analytics/UX are not blocked by ad blockers.
    return false;
  }
};
